import { uri } from '../../api-endpoint';
import {
  IProjectAPIValidationError,
  IProjectFromAPISuccessResponse
} from '../../type-conversion/project/from-api-repsonse';
import { ProjectAPIRequestBody } from '../../type-conversion/project/to-api-request-body';
import { updateTemplateFn } from '../common';

export const updateProject = (token: string) => (projectId: number) =>
  updateTemplateFn(
    token,
    uri.projectById(projectId),
    ProjectAPIRequestBody,
    IProjectFromAPISuccessResponse,
    IProjectAPIValidationError
  );
